
        <!-- Start Footer Area -->
        <footer class="footer-area pt-100 pb-75">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-5 col-sm-6">
                        <div class="single-footer-widget">
                            <div class="widget-logo">
                                <a>
                                    <img  [routerLink]="['/aboutus']" src="assets/images/cxo-logo.svg" class="black-logo pointer" alt="image">
                                </a>
                            </div>
                            <p class="footer_txt"> Our roundtable topics come directly from IT leaders like you. Every intimate discussion is shaped by the real-world challenges and interests of local technology executives, ensuring each event is timely, relevant, and impactful.</p>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6 ">
                        <div class="single-footer-widget ">
                            <h3>Our Company</h3>

                            <ul class="footer-links-list">
                                <div>
                                    <!-- <li><a class="text-decoration-none" href="">Home</a></li> -->
                                    <li><a class="text-decoration-none" href="">About Us</a></li>
                                    <li><a class="text-decoration-none"  [routerLink]="['/membership']">Membership</a></li>
                                    <li><a class="text-decoration-none" [routerLink]="['/sponsors']">Sponsors</a></li>
                                    <li><a class="text-decoration-none"  [routerLink]="['/services']">Upcoming Events</a></li>
                                    <!-- <li><a class="text-decoration-none"  href="">Contact Us</a></li> -->

                                </div>
                                
                              
                               
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="single-footer-widget">
                            <h3>Contact Us</h3>

                            <ul class="widget-info">
                                    <!-- <li><a class="text-decoration-none" href="">Program Chair: Ryan Martin</a></li> -->
                                    <li><a  class="text-decoration-none" href="mailto:support@roundtablecxo.com">Email: support&#64;roundtablecxo.com</a></li>
                                    <!-- <li><a class="text-decoration-none" href="https://www.linkedin.com/" target="_blank">Connect w/ Us: LinkedIn</a></li> -->
                                <!-- <li>
                                    <i class='bx bxs-map'></i>
                                    11285 Elkins Road, Suite D4  Roswell, GA 30076
                                </li>

                                <li>
                                    <i class='bx bxs-phone'></i>
                                    <a href="">+1 234 567 8967</a>
                                </li>

                                <li>
                                    <i class='bx bx-envelope-open'></i>
                                    <a ><span class="__cf_email__" >support&#64;roundtablecxo.com</span></a>
                                </li> -->
                            </ul>
                            <h3 class="mt-3">Connect with Us</h3>
                            <ul class="widget-social">
                                <li>
                                    <a href="https://www.linkedin.com/company/roundtablecxo" target="_blank">
                                        <i class='bx m-left bxl-linkedin'></i>
                                    </a>
                                </li>
                                <!-- <li>
                                    <a href="https://www.facebook.com/" target="_blank">
                                        <i class='bx bxl-facebook'></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/?lang=en" target="_blank">
                                        <i class='bx bxl-twitter'></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/" target="_blank">
                                        <i class='bx bxl-instagram-alt'></i>
                                    </a>
                                </li> -->
                               
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <!-- End Footer Area -->

        <!-- Start Copyright Area -->
        <div class="copyright-area">
            <div class="container">
                <div class="copyright-area-content">
                    <div class="row align-items-center">

                        <footer class="footer">
                            <div class="footer-container">
                              <p class="footer-left"> &copy; 2025 RoundtableCxO</p>
                              <div class="footer-center">
                                
                                <p class="release-version ">{{appConfig.version}}</p>
                            
                            </div>
                              <div class="footer-right">
                                <ul>
                                    <li>
                                        <a >Terms of Service</a>
                                    </li>
                                    <li>
                                        <a >Privacy Policy</a>
                                    </li>
                                </ul>
                              </div>
                            </div>
                          </footer>

                          
                        <!-- <div class="col-lg-4 col-md-4">
                            <p>
                               &copy; 2025 RoundtableCxO -->
                                <!-- <a  target="_blank">
                                    RoundtableCXO
                                </a> -->
                            <!-- </p> 
                        </div> -->

                        <!-- <div class="col-lg-4 col-md-4">
                            <div class="login-footer">
                                <div class="footer-copyrights">
                                    <p class="release-version ">{{appConfig.version}}</p> -->
                                    <!-- <p class="powered mb-0">Powered by <a href="https://qualibar.com/" target="_blank">Qualibar.com</a> -->
                                    <!-- </p> -->
                                <!-- </div>
                            </div>
                        </div> -->
                      

                        <!-- <div class="col-lg-4 col-md-4">
                            <ul>
                                <li>
                                    <a >Terms of Service</a>
                                </li>
                                <li>
                                    <a >Privacy Policy</a>
                                </li>
                            </ul>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- End Copyright Area -->

        <!-- Start Go Top Area -->
        <div class="go-top">
            <i class='bx bx-chevron-up'></i>
        </div>

       